import type { MeasureDrillDownInfo } from "../../../../../../../../../api/types/svTypes.ts";
import { MeasureUnitTable } from "../../../../../../../../../api/types/svTypes.ts";
import { getExtensionLedger } from "../ledger/extensionLedgers";

export function getLedgerTitle(drillDownInfo: MeasureDrillDownInfo | undefined): string {
  if (drillDownInfo === undefined) return "";
  const extensionLedger = getExtensionLedger(drillDownInfo.table);
  if (extensionLedger !== undefined) {
    return extensionLedger.tabTitle;
  }
  if (drillDownInfo.table === MeasureUnitTable.Memo) {
    return drillDownInfo.allocated ? "Allocated Memo Ledger" : "Memo Ledger";
  }
  return drillDownInfo.allocated ? "Allocated General Ledger" : "General Ledger";
}
